import * as R from 'ramda'
import { empty, of } from 'rxjs'
import { filter, pairwise, switchMap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { LOCATION_CHANGE, replace } from 'connected-react-router'
import { toHref } from 'helpers/PathHelper'
import {
  areValuesDifferent,
  getFiltersFromQuery,
  pathnameHasChanged
} from 'domain/filters'
import {
  getQuery,
  getSelectedFilters,
  getUri
} from 'store/selectors'

const hasFiltersChanged = R.pipe(
  R.map(getFiltersFromQuery),
  areValuesDifferent
)

const shouldUpdateQuery = pair => R.both(
  pathnameHasChanged,
  hasFiltersChanged
)(pair)

const updateFiltersQueryEpic = (
  actions$,
  state$
) => actions$.pipe(
  ofType(LOCATION_CHANGE),
  pairwise(),
  filter(shouldUpdateQuery),
  switchMap(() => {
    const query = getQuery(state$.value)
    const uri = getUri(state$.value)
    const newQuery = R.pickBy(
      R.length,
      R.map(
        R.when(R.length, R.join(',')),
        getSelectedFilters(state$.value)
      )
    )

    const oldURI = toHref({
      pathname: uri,
      query
    }, query)

    const newURI = toHref({
      pathname: uri,
      query: {
        ...(query.key && { key: query.key }),
        ...newQuery
      }
    }, query)

    if (R.not(R.equals(oldURI, newURI))) {
      return of(replace(newURI))
    }
    return empty()
  })
)

export default updateFiltersQueryEpic
